module.exports = __webpack_public_path__ + "img/ico_cultivation2.0dd21bea.png";